import * as Apollo from '@apollo/client'
import {GQL_AllBoxesWithoutRentalsQuery, GQL_AllBoxesWithoutRentalsQueryVariables, useAllBoxesWithoutRentalsQuery} from '../../../generated/graphql'
import {transformBoxWithoutRentals} from '../../../gql/transformBox'

export const useAllBoxesWithoutRentals = (
  baseOptions?: Apollo.QueryHookOptions<GQL_AllBoxesWithoutRentalsQuery, GQL_AllBoxesWithoutRentalsQueryVariables>,
) => {
  const {data, ...rest} = useAllBoxesWithoutRentalsQuery(baseOptions)
  return {
    ...rest,
    data: data?.box?.allBoxes.map(transformBoxWithoutRentals) ?? [],
  }
}
